import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Dialog, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  zIndex: 1500,

  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.colors.lockedBackground,
  },
  '& .MuiDialog-paper': {
    margin: 0,
  },
}));

export const PaperStyled = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isNewsModal',
})(({ theme, isNewsModal }) => ({
  borderRadius: '12px',
  backgroundColor: 'transparent',
  width: isNewsModal && '100% ',
  maxWidth: isNewsModal && '684px !important',
  height: '100%',
  boxShadow: 'none',

  [theme.breakpoints.up('xxxl')]: {
    height: isNewsModal ? '100%' : '70%',
  },
}));

export const StepperBoxOut = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isNewsModal',
})(({ theme, isNewsModal }) => ({
  borderRadius: '12px',
  background: theme.palette.colors.popupWindow,
  padding: '0 0 8px',
  height: '100%',
  maxHeight: isNewsModal && '853px',
  width: isNewsModal ? '100%' : '456px',

  [theme.breakpoints.down('lg')]: {
    width: '344px',
  },
}));

export const StepHeaderStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isNewsModal',
})(({ theme, isNewsModal }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.colors.popupWindowTitle,
  padding: '0 12px 0 24px',
  height: '7%',

  [theme.breakpoints.up('xxl')]: {
    height: isNewsModal && '5%',
  },
}));

export const StepHeaderLabelStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isNewsModal',
})(({ isNewsModal }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  letterSpacing: '0.39px',
  textTransform: 'uppercase',
  alignSelf: 'flex-end',
  marginBottom: '5px',
  marginTop: isNewsModal && '15px',
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(() => ({
  fontSize: '18px',
  cursor: 'pointer',
  margin: 'auto 0',
}));

export const StepperBoxIn = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'backgroundColor' && prop !== 'isNewsModal',
})(({ theme, backgroundColor, isNewsModal }) => ({
  backgroundColor: backgroundColor || theme.palette.colors.primaryBackground,
  borderRadius: '5px',
  margin: '0 8px',
  height: '93%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 8px 0 8px',

  [theme.breakpoints.down('lg')]: {
    width: '328px',
  },
  [theme.breakpoints.up('xxl')]: {
    height: isNewsModal && '95%',
  },
}));
